const HelpContent = ({ location }) => {
  if (location === '/dashboard') return 'Hola'
  else return 'Esta sección no tiene un panel de ayuda'
}

export default HelpContent
